import React, {Component} from 'react';
import {connect} from 'react-redux';
import AdvancedDisbursementTab from "../../components/ApplicationPolicy/advancedDisbursementTab";
import {
    editAdvancedDisbursement, getAdvancedDisbursementsOfAPolicy,
    getAdvanceDisbursementById, getAdvanceDisbursementsStatementMessages
} from "../../actions/advancedDisbursements";
import {getApplicationPolicyAfterAdCreate} from "../../actions/applicationPolicy";
import {
    changeAdvanceDisbursementsTabStoreSettings, closeAdModal,
    openAdModal
} from "../../actions/advanceDisbursementsTab";
// import download from "in-browser-download";
import {
    _getFileFromBase64,
    isAragUser,
    isSolicitorUser,
    extractSpecificElementOfArray,
    isGatewayPlutusLawsys
} from "../../helpers/functions";
import {getADStatementLegalEntity} from "../../helpers/advanceDisbursementsUtils";
import generatePolicyADStatement from "../../helpers/generatePolicyADStatement";
import {requestGetSolicitorDetails} from "../../actions/manageSolicitorAccount";
import {checkCasesSubCasesBetweenUserAndApplicationForm} from "../../helpers/advanceDisbursments/disableADButtons";


class AdvancedDisbursementsTabHOC extends Component {

    componentDidMount() {
        if (this.props.applicationId) {
            this.props.getAdvancedDisbursementsOfAPolicy(this.props.applicationId);
        }

        this.props.getAdvanceDisbursementsStatementMessages();
        this.props.loggedInUserRole === 'Solicitor' ?
            this.props.getSolicitorDetails(this.props.loggedInUserId)
            :
            this.props.getSolicitorDetails(this.props.applicationUserId);
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.postingAdvancedDisbursement && !nextProps.postingAdvancedDisbursement
            && !nextProps.postingAdvancedDisbursementError
        ) {
            this.props.getAdvancedDisbursementsOfAPolicy(this.props.applicationId);
            this.props.getSelectedApplication(this.props.applicationId);
        }

    }

    _getStatisticsHeader = () => {
        return [
            {key: 'total', value: 'Total', style: 'col-sm-1'},
            {key: 'advancedDisbursements', value: 'Advance Disbursements', style: 'col-sm-4'},
            {key: 'applied', value: 'Applied', style: 'col-sm-4'},
            {key: 'approved', value: 'Approved (Live)', style: 'col-sm-3'},
            {key: 'approvedAndSettled', value: 'Approved (Closed)', style: 'col-sm-3'},
        ]
    };

    _handleRowClick = (row) => {
        this.props.openAdModal();
        this.props.getAdvanceDisbursementById(row.id)
    };

    _getAdByIdAttachments = () => {
        if (this.props.advanceDisbursementById.attatchmentDtos) {
            return this.props.advanceDisbursementById.attatchmentDtos
        } else {
            return []
        }
    };

    _disableADButton = () => {
        return checkCasesSubCasesBetweenUserAndApplicationForm({
            user: this.props.User.loggedInUser,
            applicationCaseTypeId: this.props.applicationCaseTypeId,
            applicationSubCaseTypeId: this.props.applicationSubCaseTypeId
        })
    };


    // _getFileFromBase64 = (documentToDownload) => {
    //     _getFileFromBase64(documentToDownload)
    //     // download(documentToDownload.encodedFile, documentToDownload.name, documentToDownload.fileType, 'base64');
    // };

    _changeSelectedAdStatus = (evt) => {
        this.props.changeStoreSettings({
            key: evt.target.name,
            value: evt.target.value
        });
    };

    dismissSuccessAlertMessage = () => {
        this.props.changeStoreSettings({
            key: "successPatchMessage",
            value: null
        });
    };

    onDownloadStatement = () => {
        // WI: statement download disabled for solicitors - the button is disabled, but guard here too so no request can fire if triggered another way.
        if (isSolicitorUser(this.props.User.loggedInUser.roles)) {
            return;
        }

        const {aragReference, advancedDisbursements, lawsysFirm, statementMessages, systemsOfRecordId} = this.props;
        const paidPartSettledAdvanceDisbursements = advancedDisbursements.filter(a => a.disbursementStatusMachineName === "paid" || a.disbursementStatusMachineName === "part-settled");
        const pdfMake = require('pdfmake/build/pdfmake.js');
        const pdfFonts = require('pdfmake/build/vfs_fonts.js');
        pdfMake.vfs = pdfFonts.pdfMake.vfs;
        // WI 100256 - this statement is for one policy, so its own System of Record decides the entity.
        const legalEntity = getADStatementLegalEntity(
            statementMessages, isGatewayPlutusLawsys(systemsOfRecordId));
        const data = {
            advancedDisbursements: paidPartSettledAdvanceDisbursements,
            lawsysFirm,
            statementMessages: legalEntity.statementMessages,
            legalEntityName: legalEntity.legalEntityName
        };
        const generatedStatement = pdfMake.createPdf(generatePolicyADStatement(data));
        const fileName = `Advance_Disbursements_Statement_${aragReference}.pdf`;
        generatedStatement.download(fileName)
    };

    render() {
        const disableAdvancedDisbursementsButton = this._disableADButton();
        const isSolicitor = isSolicitorUser(this.props.User.loggedInUser.roles);

        return (
            <AdvancedDisbursementTab
                onDownloadStatement={this.onDownloadStatement}
                isSolicitor={isSolicitor}
                dismissSuccessAlertMessage={this.dismissSuccessAlertMessage}
                applicationPolicyId={this.props.applicationId}
                advanceDisbursementById={this.props.advanceDisbursementById}
                isAragUser={this.props.isAragUser}
                patchingAdvanceDisbursement={this.props.patchingAdvanceDisbursement}
                _changeSelectedAdStatus={this._changeSelectedAdStatus}
                _getFileFromBase64={_getFileFromBase64}
                _closeAdModal={this.props.closeAdModal}
                advanceDisbursementsTab={this.props.advanceDisbursementsTab}
                fetchingAdById={this.props.fetchingAdById}
                advanceDisbursementByIdAttachments={this._getAdByIdAttachments()}
                _handleRowClick={this._handleRowClick}
                loggedInUserRole={this.props.loggedInUserRole}
                applicationPolicyStatus={this.props.applicationPolicyStatus}
                fetchingAdvancedDisbursements={this.props.fetchingAdvancedDisbursements}
                statisticsHeader={this._getStatisticsHeader()}
                totalNumberOfApplied={this.props.aDTotalAppliedRecords}
                totalNumberOfAdvancedDisbursements={this.props.aDTotalRecords}
                totalNumberOfApproved={this.props.aDTotalApprovedRecords}
                totalValueOfAdvancedDisbursements={this.props.aDTotalValue}
                totalValueOfApplied={this.props.aDTotalAppliedValue}
                totalValueOfApproved={this.props.aDTotalApprovedValue}
                totalSettledRecords={this.props.totalSettledRecords}
                totalPartSettledValue={this.props.totalPartSettledValue}
                totalSettledValue={this.props.totalSettledValue}
                advancedDisbursements={this.props.advancedDisbursements}
                _openAdvancedDisbursementsApplicationModal={this.props._openAdvancedDisbursementsApplicationModal}
                totalRejectedValue={this.props.totalRejectedValue}
                totalRejectedRecords={this.props.totalRejectedRecords}
                totalProcessingRecords={this.props.totalProcessingRecords}
                totalProcessingValue={this.props.totalProcessingValue}
                totalPaidRecords={this.props.totalPaidRecords}
                totalPaidValue={this.props.totalPaidValue}
                disableAdvancedDisbursementsButton={disableAdvancedDisbursementsButton}
                totalPartSettledRecords={this.props.totalPartSettledRecords}

            />
        )
    }
}

const mapStateToProps = (state) => {
    return {
        patchingAdvanceDisbursement: state.advancedDisbursements.patching,
        advanceDisbursementsTab: state.advanceDisbursementsTab,
        fetchingAdById: state.advancedDisbursements.fetchingById,
        advanceDisbursementById: state.advancedDisbursements.advanceDisbursementById,
        loggedInUserRole: state.user.loggedInUser.roles.length > 0 ? state.user.loggedInUser.roles[0] : '',
        loggedInUserId: state.user.loggedInUser.id ? state.user.loggedInUser.id : '',
        applicationPolicyStatus: state.newApplication.selectedApplication.policyStatus,
        applicationId: state.newApplication.selectedApplication.id ? state.newApplication.selectedApplication.id : '',
        applicationUserId: state.newApplication.selectedApplication.applicationUserId ? state.newApplication.selectedApplication.applicationUserId : '',
        aragReference: state.newApplication.selectedApplication.aragReference,
        systemsOfRecordId: state.newApplication.selectedApplication.systemsOfRecordId,
        advancedDisbursements: state.advancedDisbursements.advancedDisbursements,
        fetchingAdvancedDisbursements: state.advancedDisbursements.fetching,
        postingAdvancedDisbursement: state.advancedDisbursements.posting,
        postingAdvancedDisbursementError: state.advancedDisbursementsForm.failedResponseMsg,
        aDTotalAppliedRecords: state.advancedDisbursements.totalAppliedRecords,
        aDTotalAppliedValue: state.advancedDisbursements.totalAppliedValue,
        aDTotalApprovedRecords: state.advancedDisbursements.totalApprovedRecords,
        aDTotalApprovedValue: state.advancedDisbursements.totalApprovedValue,
        aDTotalRecords: state.advancedDisbursements.totalRecords,
        aDTotalValue: state.advancedDisbursements.totalValue,
        totalSettledRecords: state.advancedDisbursements.totalSettledRecords,
        totalPartSettledRecords: state.advancedDisbursements.totalPartSettledRecords,
        totalSettledValue: state.advancedDisbursements.totalSettledValue,
        totalPartSettledValue: state.advancedDisbursements.totalPartSettledValue,
        totalRejectedValue: state.advancedDisbursements.totalRejectedValue,
        totalRejectedRecords: state.advancedDisbursements.totalRejectedRecords,
        totalProcessingRecords: state.advancedDisbursements.totalProcessingRecords,
        totalProcessingValue: state.advancedDisbursements.totalProcessingValue,
        totalPaidRecords: state.advancedDisbursements.totalPaidRecords,
        totalPaidValue: state.advancedDisbursements.totalPaidValue,
        isAragUser: isAragUser(state.user.loggedInUser.roles),
        lawsysFirm: state.manageSolicitorAccount.solicitorData,
        statementMessages: state.advancedDisbursements.statementMessages,
        fetchingStatementMessages: state.advancedDisbursements.fetchingStatementMessages,
        applicationCaseTypeId: state.newApplication.selectedApplication.caseTypeId ? state.newApplication.selectedApplication.caseTypeId : null,
        applicationSubCaseTypeId: state.newApplication.selectedApplication.subCaseTypeId ? state.newApplication.selectedApplication.subCaseTypeId : null,
        solicitorUserAllowedToApplyForDisbursements: state.user.loggedInUser.solicitorUserAllowedToApplyForDisbursements,
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        getAdvancedDisbursementsOfAPolicy: (policyId) => {
            dispatch(getAdvancedDisbursementsOfAPolicy(policyId))
        },
        getSelectedApplication: (id) => {
            dispatch(getApplicationPolicyAfterAdCreate(id))
        },
        changeStoreSettings: (payload) => {
            dispatch(changeAdvanceDisbursementsTabStoreSettings(payload))
        },
        getAdvanceDisbursementById: (payload) => {
            dispatch(getAdvanceDisbursementById(payload))
        },
        openAdModal: () => {
            dispatch(openAdModal())
        },
        closeAdModal: () => {
            dispatch(closeAdModal())
        },
        editAdvancedDisbursement: (payload) => {
            dispatch(editAdvancedDisbursement(payload))
        },
        getSolicitorDetails: (id) => {
            dispatch(requestGetSolicitorDetails(id))
        },
        getAdvanceDisbursementsStatementMessages: (payload) => {
            dispatch(getAdvanceDisbursementsStatementMessages(payload))
        }
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(AdvancedDisbursementsTabHOC)
